import { useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import PageTransition from '../components/PageTransition';

export default function NotFound() {
  const navigate = useNavigate();
  const { isLoggedIn } = useSelector((state) => state.auth);

  const primaryAction = () => navigate(isLoggedIn ? '/' : '/login');
  const secondaryAction = () => navigate(-1);

  return (
    <PageTransition>
      <div className="container mx-auto flex items-center justify-center">
        <div className="max-w-xl w-full bg-white shadow-xl rounded-2xl border border-slate-100 p-10 text-center">
          {/* Illustration */}
          <div className="mx-auto mb-6 w-full flex justify-center">
            <svg
              className="w-64 h-40 text-blue-500"
              viewBox="0 0 320 200"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <circle cx="70" cy="120" r="36" fill="#E0F2FE" />
              <circle cx="220" cy="90" r="26" fill="#DBEAFE" />
              <rect
                x="90"
                y="80"
                width="140"
                height="70"
                rx="14"
                fill="#EFF6FF"
                stroke="#BFDBFE"
                strokeWidth="4"
              />
              <path
                d="M110 110h40"
                stroke="#60A5FA"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M170 110h40"
                stroke="#60A5FA"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <path
                d="M140 135h40"
                stroke="#A5B4FC"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <circle cx="95" cy="155" r="6" fill="#60A5FA" />
              <circle cx="225" cy="155" r="6" fill="#A5B4FC" />
              <path
                d="M60 160c10 12 40 18 60 18h80c20 0 50-6 60-18"
                stroke="#E2E8F0"
                strokeWidth="6"
                strokeLinecap="round"
              />
              <circle cx="40" cy="50" r="6" fill="#A5B4FC" />
              <circle cx="270" cy="40" r="8" fill="#60A5FA" />
              <circle cx="295" cy="70" r="4" fill="#93C5FD" />
            </svg>
          </div>
          <h1 className="text-3xl font-bold text-slate-900 mb-3">页面未找到</h1>
          <p className="text-slate-600 mb-8 leading-relaxed">
            你访问的链接不存在，或已被移除。请返回首页继续浏览。
          </p>
          <div className="flex flex-col sm:flex-row gap-3 justify-center">
            <button
              onClick={primaryAction}
              className="px-5 py-3 rounded-lg bg-blue-600 hover:bg-blue-700 text-white font-semibold transition-colors duration-200 cursor-pointer"
            >
              返回首页
            </button>
            <button
              onClick={secondaryAction}
              className="px-5 py-3 rounded-lg bg-white border border-slate-200 text-slate-700 hover:bg-slate-50 font-semibold transition-colors duration-200 cursor-pointer"
            >
              返回上一页
            </button>
          </div>
        </div>
      </div>
    </PageTransition>
  );
}
